import React from "react";
var __jsx = React.createElement;
import SAR from "@componentsShared/SAR/SAR";
import { useTranslation } from "@i18n";
import Markdown from "markdown-to-jsx";
var PriceRow = function PriceRow(_ref) {
  var label = _ref.label,
    value = _ref.value,
    note = _ref.note;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-5 text-[#6B7EA5]"
  }, label), /*#__PURE__*/React.createElement("p", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-black-primary text-base font-bold leading-6"
  }, value), /*#__PURE__*/React.createElement(SAR, {
    className: "text-black-primary"
  }))), note && /*#__PURE__*/React.createElement("p", {
    className: "text-xs leading-4 text-[#6B7EA5]"
  }, note));
};
var PostInfoDesktop = function PostInfoDesktop(_ref2) {
  var _warranty$price;
  var onClose = _ref2.onClose,
    details = _ref2.details;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var warranty = details.warrantyPriceDetailsV3;
  var isWarrantyFree = (warranty === null || warranty === void 0 ? void 0 : warranty.is_free) || !warranty;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pt-10 pb-4 px-[clamp()] flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[532px] w-full flex flex-col gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary-new text-2xl font-bold leading-8"
  }, tShort("post_info/title", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary leading-8"
  }, details.post_title)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full rounded bg-[#F2F2F2] pt-3 pb-6 px-4 flex flex-col gap-4 [mask-image:radial-gradient(circle_at_left_center,transparent_10px,black_11px),radial-gradient(circle_at_right_center,transparent_10px,black_11px)] [mask-composite:intersect] relative"
  }, /*#__PURE__*/React.createElement(PriceRow, {
    label: tShort("post_info/car_price", {
      ns: "web_tracking"
    }),
    value: details.post_price
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t-2 border-dashed border-[#E0E0E0] w-full"
  }), /*#__PURE__*/React.createElement(PriceRow, {
    label: tShort("post_info/vat", {
      ns: "web_tracking"
    }),
    value: details.vat,
    note: details.vat_note
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t-2 border-dashed border-[#E0E0E0] w-full"
  }), /*#__PURE__*/React.createElement(PriceRow, {
    label: tShort("post_info/registration_fees", {
      ns: "web_tracking"
    }),
    value: details.registration_fees
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t-2 border-dashed border-[#E0E0E0] w-full"
  }), /*#__PURE__*/React.createElement(PriceRow, {
    label: tShort("post_info/shipping", {
      ns: "web_tracking"
    }),
    value: details.shipping_fees,
    note: details.shipping_fees_show_note ? details.shipping_fees_add_text : undefined
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t-2 border-dashed border-[#E0E0E0] w-full"
  }), details.coupon_fees && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceRow, {
    label: tShort("post_info/coupon_fees", {
      ns: "web_tracking"
    }),
    value: details.coupon_fees
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t-2 border-dashed border-[#E0E0E0] w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-5 text-[#6B7EA5] flex items-center gap-1"
  }, tShort("post_info/warranty", {
    ns: "web_tracking"
  }), /*#__PURE__*/React.createElement(Markdown, {
    className: "text-navy-primary font-medium text-xs [&>strong]:font-bold"
  }, warranty === null || warranty === void 0 ? void 0 : warranty.title)), isWarrantyFree ? /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary text-base font-bold leading-6"
  }, tShort("post_info/warranty_included", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement("p", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-black-primary text-base font-bold leading-6"
  }, warranty === null || warranty === void 0 ? void 0 : (_warranty$price = warranty.price) === null || _warranty$price === void 0 ? void 0 : _warranty$price.current_formatted))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-3 left-0 h-[14px] w-full bg-[radial-gradient(circle_at_14px_14px,#fff_14px,transparent_15px)] bg-[size:39px_28px] bg-repeat-x",
    style: {
      transform: "translateY(100%)"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "h-px w-full bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-normal leading-7 text-[#6B7EA5]"
  }, tShort("post_info/total", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-2xl font-bold leading-8 text-success"
  }, details.total_price, /*#__PURE__*/React.createElement(SAR, {
    className: "text-success"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "w-full outline-0 border-0 bg-primary-new text-white rounded px-4 py-3 text-base font-bold leading-6 md:max-w-[318px] cursor-pointer",
    onClick: onClose
  }, tShort("post_info/done", {
    ns: "web_tracking"
  }))))));
};
export default PostInfoDesktop;